import { SVGProps } from "react";

export const Warning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="30"
    height="28"
    viewBox="0 0 30 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0025 0C13.4232 0 12.0102 0.843113 11.2262 2.24881L0.592404 21.2479C-0.197468 22.6592 -0.197468 24.3399 0.592404 25.7512C1.38227 27.1625 2.79484 28 4.3687 28H25.6313C27.2106 28 28.6236 27.1569 29.4076 25.7512C30.1975 24.3399 30.1975 22.6592 29.4076 21.2479L18.7788 2.24881C17.9947 0.843472 16.5818 0 15.0025 0ZM27.9672 24.8852C27.4776 25.7571 26.6102 26.2733 25.6313 26.2733H4.3687C3.39532 26.2733 2.52202 25.7511 2.03279 24.8852C1.54319 24.0133 1.54319 22.9749 2.03279 22.103L12.6666 3.11001C13.1562 2.23809 14.0291 1.72187 15.0025 1.72187C15.9759 1.72187 16.8492 2.24407 17.3384 3.11001L27.9722 22.103C28.4563 22.9749 28.4563 24.0132 27.9667 24.8852H27.9672Z"
      fill="#354967"
    />
    <path
      d="M15 7C14.4465 7 14 7.5363 14 8.19983V17.8002C14 18.4643 14.447 19 15 19C15.5535 19 16 18.4637 16 17.8002V8.19983C16 7.5363 15.5535 7 15 7Z"
      fill="#354967"
    />
    <path
      d="M14.2935 21.2817C14.247 21.3285 14.207 21.3758 14.167 21.4292C14.1335 21.4896 14.1005 21.5434 14.0735 21.6038C14.0535 21.6642 14.0335 21.7312 14.02 21.7916C14.0065 21.8585 14 21.9259 14 21.9929C14 22.2612 14.1065 22.5098 14.2935 22.7046C14.387 22.7987 14.4935 22.8722 14.62 22.9195C14.74 22.9733 14.8665 23 15 23C15.1335 23 15.26 22.9733 15.38 22.9195C15.5065 22.8726 15.6135 22.7987 15.7065 22.7046C15.893 22.5098 16 22.2616 16 21.9929C16 21.7246 15.8935 21.4694 15.7065 21.2812C15.334 20.9062 14.6605 20.9062 14.2935 21.2817L14.2935 21.2817Z"
      fill="#354967"
    />
  </svg>
)
